import * as Yup from 'yup';
import * as React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { useState, useEffect } from 'react';

// material
import Moment from 'moment';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import {
    Accordion, TextareaAutosize, Autocomplete, Stack, TextField, Radio, FormControl, Grid, Tooltip, InputLabel, Select, FormControlLabel, Checkbox, Modal, IconButton, Typography, MenuItem, Button, Box, CardMedia, Tabs, Tab, FormHelperText, RadioGroup, Card, Divider, FormLabel, AccordionDetails, CardContent, Menu, ListItemIcon, ListItemText, FormGroup
}
    from '@mui/material';
import { DataGrid, GridToolbar, GridPagination } from '@mui/x-data-grid';
import { styled } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import EditIcon from '@mui/icons-material/Edit';
import ListIcon from '@mui/icons-material/List';
import CloseIcon from '@mui/icons-material/Close';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import DownloadIcon from "@mui/icons-material/Download";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import Iconify from '../../Iconify';


import ModalPopUp from '../../Common/ModalPopUp';
// -----------------------------------------------------------------------------------------------------


const accordionStyle = {
    backgroundColor: '#FFFFFF',
    minHeight: '10px',
    height: '40px',
    marginBottom: '5px',
    display: 'flex',
    justifyContent: 'space-between',


    // Add other CSS properties as needed
};

const style = {
    position: 'absolute',
    top: '50%',
    justifyContent: 'center',
    left: '50%',
    transform: 'translate(-50%, -50%)',

    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 10,
    p: 4,
};
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    bgcolor: 'background.paper',
    boxShadow: 24,

    maxHeight: '80vh',
    overflow: 'auto',
    borderRadius: '8px',
};
const observationModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    maxHeight: '80vh',
    overflow: 'auto',
    borderRadius: '8px',
};
const historyModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '92%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    maxHeight: '80vh',
    overflow: 'auto',
    borderRadius: '8px',
};

const AntTabs = styled(Tabs)({
    borderBottom: '1px solid #4e342e',
    position: 'sticky',
    '& .MuiTabs-indicator': {

    },
});
const AntTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    textTransform: 'none',
    minWidth: 0,
    [theme.breakpoints.up('sm')]: {
        minWidth: 0,
    },
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(1),
    fontsize: '20px',
    color: '#E7000B',
    Transition: '2s',
    fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
        color: '#4e342e',

        opacity: 1,
    },
    '&.Mui-selected': {
        color: '#4e342e',

        fontWeight: theme.typography.fontWeightMedium,

    },
    '&.Mui-focusVisible': {
        backgroundColor: '#fff',
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 1 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}
const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function ServiceEntryPage({
    handleServiceDate, serviceDate, handleContactPerson, contactPerson, selectedContactPerson, contactDetails, handleContactDetails, handleServiceType, serviceType, selectedServiceType, timeType, ServiceEntries, handleInputChange, handleAddNewEntry, selectedServiceActivity, handleServiceActivity, serviceEntryRemark, handleServiceEntryRemark, activityTypeModal, handelActivityOpenClick, handelActivityCancelClick, activityTypeService, activityTypeServiceData, handleSelectFile, requestFile, removeFile, forCancelConfirm, message, openModalForCancel, handleDrop, handleDragOver, handleDrgaDropClick,
    setOpenModalCancel, downloadUploadedFile, disableDownloadBtn,
    handleBlur, pageSize4, setPageSize4, handleServiceRemarkChange, handleTimeTypeChange, expandedAccordion, setExpandedAccordion,
    handleServiceReset, handleSaveServiceClick, handleSaveServiceConfirm, openModalForSaveService, setOpenModalForSaveService, setOpenModalForDeleteService,
    handleDeleteServiceConfirm, openModalForDeleteService, deleteIndex, setDeleteIndex, open, handleObservationClick, handleClose, fromEdit,

    handleObservationHistoryOpenClick, handleObservationModal, isShowToClient, handleCheckbox, isLoading
}) {
    const CustomPagination = (props) => <GridPagination {...props} />;
    const stripHtml = (html) => {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        return temp.textContent || temp.innerText || '';
    };
    return (
        <>
            <Box sx={{ display: 'flex', gap: 2, width: '100%', mt: 2, px: 2, }}>
                {/* Left Card */}
                <Card
                    sx={{
                        width: '60%',
                        height: '460px',
                        borderRadius: 2,
                        boxShadow: 1,
                        border: '1px solid #E5E5E5',
                        backgroundColor: '#fff', // Ensure visible
                    }}
                >
                    <CardContent
                        sx={{
                            p: 2, display: 'flex',
                            flexDirection: 'column',
                            height: '100%',
                            overflow: 'hidden',
                        }}>

                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Icon
                                    icon="material-symbols:list-alt-check-outline-rounded"
                                    width={20}
                                    height={20}
                                    color="#4A5565"
                                />
                                <Typography sx={{ fontSize: 14, color: '#121212', fontWeight: 600 }}>Service</Typography>

                            </Box>
                            {!fromEdit && (
                                <Stack direction="row" spacing={1}>

                                    <Button
                                        variant="contained"
                                        size="small"
                                        onClick={handleAddNewEntry}
                                        startIcon={<Icon icon="material-symbols:add" width={20} />}
                                        color="secondary"
                                        sx={{ fontSize: 12, height: 30 }}
                                    >
                                        Add Service
                                    </Button>

                                </Stack>
                            )}
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 4, mt: 3, mb: 2 }}>
                            {/* Service Date with FormLabel */}
                            <Box>
                                <FormLabel sx={{ mb: 1, display: 'block' }}>Service Date</FormLabel>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        inputFormat="dd/MMM/yyyy"
                                        value={serviceDate}
                                        onChange={handleServiceDate}
                                        renderInput={(params) => <TextField size="small" {...params} sx={{ width: 280 }} />}
                                        disableFuture

                                    />
                                </LocalizationProvider>
                            </Box>

                            {/* Time Configuration with inline radio */}
                            <Box>
                                <FormLabel sx={{ mb: 1, display: 'block' }}>Time Configuration</FormLabel>
                                <RadioGroup
                                    row
                                    value={timeType}
                                    onChange={(e) => handleTimeTypeChange(e.target.value)}
                                >
                                    <FormControlLabel value="from-to" control={<Radio />} label="From-To Time" />
                                    <FormControlLabel value="in-minutes" control={<Radio />} label="In Minutes" />
                                </RadioGroup>
                            </Box>
                        </Box>

                        <Box sx={{
                            flex: 1,
                            pb: 0,
                        }}>
                            <Box
                                sx={{
                                    overflowY: "auto",
                                    maxHeight: "230px",
                                    pr: 1,
                                }}
                            >
                                <Stack spacing={2} sx={{ mt: 1, }}>
                                    {ServiceEntries.map((entry, index) => (

                                        <Accordion key={index}
                                            expanded={expandedAccordion === index}
                                            onChange={() =>
                                                setExpandedAccordion(expandedAccordion === index ? null : index)
                                            }
                                            sx={{
                                                border: '1px solid #E5E5E5', // Light gray border
                                                borderRadius: "15px",
                                                boxShadow: 'none',
                                                overflow: "hidden",
                                            }}
                                        >
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                sx={{
                                                    backgroundColor: '#FFFF',
                                                    minHeight: 40, // Tighten the vertical space
                                                    px: 2, // Optional horizontal padding
                                                    '&.Mui-expanded': {
                                                        minHeight: 40, // Ensure height stays even when expanded
                                                    },
                                                    '& .MuiAccordionSummary-content': {
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                        margin: 0,
                                                    },
                                                    '& .MuiAccordionSummary-content.Mui-expanded': {
                                                        margin: 0,
                                                    },
                                                }}
                                            >

                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 2, // space between Service text and checkbox block
                                                    }}
                                                >
                                                    <Typography fontWeight="bold">
                                                        # Service - {index + 1}
                                                    </Typography>

                                                    <FormControlLabel
                                                        sx={{
                                                            m: 0,              // remove default margin
                                                            p: 0,
                                                            gap: 0.5,          // small gap between checkbox & label
                                                        }}
                                                        control={
                                                            <Checkbox
                                                                checked={entry.isShowToClient}
                                                                onChange={handleCheckbox(index)}
                                                                sx={{
                                                                    p: 0,      // remove checkbox padding
                                                                }}
                                                                icon={
                                                                    <Box
                                                                        sx={{
                                                                            width: 18,
                                                                            height: 18,
                                                                            border: '1px solid #D1D5DB',
                                                                            borderRadius: '4px',
                                                                        }}
                                                                    />
                                                                }
                                                                checkedIcon={
                                                                    <Box
                                                                        sx={{
                                                                            width: 18,
                                                                            height: 18,
                                                                            border: '1px solid #D1D5DB',
                                                                            borderRadius: '4px',
                                                                            backgroundColor: '#1976d2',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            color: '#fff',
                                                                            fontSize: 14,
                                                                        }}
                                                                    >
                                                                        ✓
                                                                    </Box>
                                                                }
                                                            />
                                                        }
                                                        label="Add to Reporting"
                                                    />
                                                </Box>


                                                {/* Add delete button INSIDE summary but AFTER title */}
                                                {ServiceEntries.length > 1 && (
                                                    <IconButton
                                                        edge="end"
                                                        size="small"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setDeleteIndex(index); // store index
                                                            setOpenModalForDeleteService(true); // show popup
                                                        }}
                                                        sx={{
                                                            color: '#FF1744',
                                                            '&:hover': {
                                                                backgroundColor: 'rgba(255,23,68,0.1)',
                                                            },
                                                        }}
                                                    >
                                                        <Icon icon="material-symbols:delete-outline" width={20} height={20} />


                                                    </IconButton>
                                                )}
                                            </AccordionSummary>

                                            <AccordionDetails>
                                                <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                                                    {timeType === 'in-minutes' ? (
                                                        <>
                                                            <FormControl size="small" fullWidth>
                                                                <FormLabel>Start Min</FormLabel>

                                                                <TextField
                                                                    size="small"
                                                                    type="text"
                                                                    value={entry.startMin}
                                                                    onChange={(e) => handleInputChange(index, "startMin", e.target.value)}
                                                                    onBlur={() => handleBlur(index, "startMin")}
                                                                    placeholder="HH:mm"
                                                                    error={Boolean(entry.startMinError)}
                                                                    helperText={entry.startMinError}
                                                                    inputProps={{ maxLength: 5 }}
                                                                />


                                                            </FormControl>

                                                            <FormControl size="small" fullWidth>
                                                                <FormLabel>No. of Min</FormLabel>

                                                                <TextField
                                                                    size="small"
                                                                    type="number"
                                                                    fullWidth
                                                                    value={entry.minute}
                                                                    onChange={(e) => handleInputChange(index, "minute", e.target.value)}
                                                                />

                                                            </FormControl>

                                                        </>
                                                    ) : (
                                                        <>
                                                            <FormControl size="small" fullWidth>
                                                                <FormLabel>From Time</FormLabel>
                                                                <TextField
                                                                    size="small"
                                                                    type="text"
                                                                    value={entry.fromTime}
                                                                    onChange={(e) => handleInputChange(index, "fromTime", e.target.value)}
                                                                    onBlur={() => handleBlur(index, "fromTime")}
                                                                    placeholder="HH:mm"
                                                                    error={Boolean(entry.fromTimeError)}
                                                                    helperText={entry.fromTimeError}
                                                                    inputProps={{ maxLength: 5 }}
                                                                />

                                                            </FormControl>

                                                            <FormControl size="small" fullWidth>
                                                                <FormLabel>To Time</FormLabel>

                                                                <TextField
                                                                    size="small"
                                                                    type="text"
                                                                    value={entry.toTime}
                                                                    onChange={(e) => handleInputChange(index, "toTime", e.target.value)}
                                                                    onBlur={() => handleBlur(index, "toTime")}
                                                                    placeholder="HH:mm"
                                                                    error={Boolean(entry.toTimeError)}
                                                                    helperText={entry.toTimeError}
                                                                    inputProps={{ maxLength: 5 }}
                                                                />

                                                            </FormControl>
                                                        </>
                                                    )}

                                                    <FormControl size="small" fullWidth>
                                                        {/* Label and Icon side by side */}
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                            <FormLabel>Activity Type</FormLabel>
                                                            {index === 0 && (
                                                                <IconButton size="small" sx={{ color: 'green', padding: '2px' }} onClick={handelActivityOpenClick}>
                                                                    <HelpOutlineIcon fontSize="small" />
                                                                </IconButton>
                                                            )}
                                                        </Box>

                                                        <Select
                                                            size="small"
                                                            value={entry.serviceActivity}
                                                            MenuProps={{
                                                                PaperProps: {
                                                                    sx: {
                                                                        backgroundColor: '#fbe9e7',
                                                                        maxHeight: '200px',
                                                                        width: '200px',
                                                                    },
                                                                },
                                                            }}
                                                            onChange={(e) => handleServiceActivity(index, e.target.value)}
                                                        >
                                                            {selectedServiceActivity.map((act) => (
                                                                <MenuItem key={act.Id} value={act.Id}>
                                                                    {act.Name}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>

                                                </Stack>

                                                <FormLabel sx={{ mt: 2 }}>
                                                    Service Provided{' '}
                                                    <Typography component="span" sx={{ color: 'red', fontSize: 12 }}>
                                                        (Avoid using &lt;, \, ' special characters)
                                                    </Typography>
                                                </FormLabel>

                                                <TextField
                                                    fullWidth
                                                    multiline
                                                    minRows={3}
                                                    placeholder="Describe the service provided in detail.."
                                                    size="small"
                                                    value={stripHtml(entry.serviceRemark)}
                                                    onChange={(e) => handleServiceRemarkChange(index, e)}
                                                    sx={{
                                                        backgroundColor: '#f5f5f5',
                                                        mt: 1,
                                                        borderRadius: 2,
                                                    }}

                                                />

                                                {/* Activity Modal */}
                                                <Modal open={activityTypeModal} onClose={handelActivityCancelClick}>
                                                    <Box sx={modalStyle}>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                padding: '10px 16px',
                                                                borderBottom: '1px solid #E0E0E0',
                                                                backgroundColor: '#fff',
                                                                m: 0, // remove outer margins
                                                            }}
                                                        >
                                                            <Typography variant="h6" fontWeight='bold'>
                                                                Activity Type
                                                            </Typography>
                                                            <IconButton
                                                                onClick={handelActivityCancelClick}
                                                                sx={{
                                                                    color: 'grey',
                                                                }}
                                                            >
                                                                <CloseIcon />
                                                            </IconButton>
                                                        </Box>


                                                        <div style={{ height: '62vh', width: '100%', padding: 2 }}>
                                                            <DataGrid
                                                                rows={activityTypeServiceData}
                                                                columns={activityTypeService}
                                                                density="compact"
                                                                getRowId={(row) => row.id || activityTypeServiceData.indexOf(row)}
                                                                components={{ Toolbar: GridToolbar, Pagination: CustomPagination }}
                                                                pagination
                                                                paginationMode="client"
                                                                rowsPerPageOptions={[25, 50, 100]}
                                                                pageSize={pageSize4}
                                                                onPageSizeChange={(newPageSize) => setPageSize4(newPageSize)}
                                                            />
                                                        </div>
                                                    </Box>
                                                </Modal>
                                            </AccordionDetails>
                                        </Accordion>
                                    ))}
                                </Stack>
                            </Box>
                        </Box>
                        {/* Footer */}
                        <Box
                            sx={{
                                position: 'sticky',
                                bottom: 0,
                                backgroundColor: '#fff',
                                mt: 2,
                                py: 1,
                                display: 'flex',
                                justifyContent: 'space-between', // space between left & right sections
                                alignItems: 'center',
                            }}
                        >
                            {/* Left side */}
                            <Box sx={{ display: "flex", gap: 1 }}>
                                {disableDownloadBtn && (
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        startIcon={<Icon icon="material-symbols:download-rounded" width={18} />}
                                        sx={{
                                            borderColor: '#FFE6E6', color: '#985252', backgroundColor: '#FFF9F9', textTransform: 'none', fontWeight: 'bold', '&:hover': {
                                                border: '1px solid #FFE6E6',   // keep same border
                                                backgroundColor: '#FFF9F9',    // keep same bg
                                            },
                                        }}
                                        onClick={downloadUploadedFile}
                                    >
                                        Uploaded file
                                    </Button>
                                )}
                                <Button
                                    variant="outlined"
                                    size="small"
                                    endIcon={<Icon icon="mingcute:right-line" width={16} />}
                                    sx={{
                                        borderColor: "#D0E2FF",
                                        color: "#0066FF",
                                        backgroundColor: "#F5F9FF",
                                        textTransform: "none",
                                        fontWeight: 600,
                                        '&:hover': {
                                            border: '1px solid #D0E2FF',   // keep same border
                                            backgroundColor: '#F5F9FF',    // keep same bg
                                        },
                                    }}
                                    onClick={handleObservationClick}
                                >
                                    Observation
                                </Button>

                                {/* Observation Menu */}
                                <Menu
                                    anchorReference="anchorPosition"
                                    anchorPosition={
                                        disableDownloadBtn
                                            ? { top: 452, left: 300 }
                                            : { top: 452, left: 165 }
                                    }
                                    open={open}
                                    onClose={handleClose}
                                    anchorOrigin={{
                                        vertical: "bottom",
                                        horizontal: "left",
                                    }}
                                    transformOrigin={{
                                        vertical: "top",
                                        horizontal: "left",
                                    }}
                                    PaperProps={{
                                        sx: {
                                            mt: 0.5,
                                            borderRadius: 2,
                                            boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                                            minWidth: 140,
                                        },
                                    }}
                                >
                                    <MenuItem onClick={handleObservationModal}>
                                        <ListItemIcon>
                                            <Icon icon="material-symbols:add" width={18} />
                                        </ListItemIcon>
                                        <ListItemText primary="Add New" />
                                    </MenuItem>
                                    <MenuItem onClick={handleObservationHistoryOpenClick}>
                                        <ListItemIcon>
                                            <Icon icon="mdi:history" width={18} />
                                        </ListItemIcon>
                                        <ListItemText primary="History" />
                                    </MenuItem>
                                </Menu>

                            </Box>
                            <Box sx={{ display: 'flex', gap: 2 }}>

                                <Button variant="outlined" color="inherit" sx={{ backgroundColor: '#F3F4F6' }} onClick={handleServiceReset}>
                                    Reset
                                </Button>

                                <LoadingButton
                                    size="medium"
                                    type="submit"
                                    variant="contained" color='primary' onClick={handleSaveServiceClick}
                                    loading={isLoading}
                                >
                                    Save Service
                                </LoadingButton>

                            </Box>
                        </Box>
                    </CardContent>
                </Card>

                {/* Right Card */}
                <Box sx={{ width: '40%', display: 'flex', flexDirection: 'column', gap: 2 }}>
                    {/* Right Card */}
                    <Card
                        sx={{
                            height: '272px',
                            borderRadius: 2,
                            boxShadow: 1,
                            border: '1px solid #E5E5E5',
                            backgroundColor: '#fff',

                        }}
                    >
                        <CardContent>
                            <Stack spacing={2}>
                                <Stack direction="row" spacing={2}>
                                    <FormControl size="small" fullWidth>
                                        <FormLabel>Contact Person</FormLabel>
                                        <Autocomplete
                                            fullWidth
                                            size="small"
                                            id="contact"
                                            value={selectedContactPerson.find((option) => option.id === contactPerson) || ""}
                                            onChange={(_, newValue) => handleContactPerson(newValue)}
                                            options={selectedContactPerson}
                                            getOptionLabel={(option) => option.Name || ""}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            renderInput={(params) => <TextField {...params} placeholder="Select Option" />}
                                            disabled={fromEdit}
                                        />
                                    </FormControl>
                                    <FormControl size="small" fullWidth>
                                        <FormLabel>Contact Details</FormLabel>
                                        <TextField fullWidth placeholder="Contact Details" size="small" value={contactDetails} onChange={handleContactDetails} disabled={fromEdit} />
                                    </FormControl>
                                </Stack>

                                <FormControl size="small" fullWidth>
                                    <FormLabel>Service Type</FormLabel>
                                    <Select
                                        size="small"
                                        value={serviceType}
                                        MenuProps={{
                                            PaperProps: {
                                                sx: {
                                                    backgroundColor: '#fbe9e7',
                                                    maxHeight: '200px',
                                                    width: '200px',
                                                }
                                            }
                                        }}
                                        type="number"
                                        onChange={(e) => handleServiceType(e.target.value)} // Update specific entry
                                    >
                                        <MenuItem key={-1} value={""} onClick={() => handleServiceType()} >Select</MenuItem>

                                        {selectedServiceType.map((act) => (
                                            <MenuItem key={act.Id} value={act.Id}>
                                                {act.Name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl size="small" fullWidth>
                                    <FormLabel>Remark</FormLabel>
                                    <TextareaAutosize
                                        minRows={3}
                                        placeholder="Remark"
                                        style={{
                                            width: "100%",
                                            resize: "none",
                                            fontFamily: "sans-serif",
                                            border: "1px solid #E5E5E5",
                                            borderRadius: "4px",
                                            padding: "8px",
                                        }}
                                        value={serviceEntryRemark}
                                        onChange={handleServiceEntryRemark}
                                    />
                                </FormControl>
                            </Stack>
                        </CardContent>
                    </Card>
                    {/* Before Upload: First Image Style */}
                    {requestFile.length === 0 ? (
                        <Box
                            component="label"
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
                            onClick={handleDrgaDropClick}
                            sx={{
                                border: '2px solid transparent',

                                // Use the borderImageSource with an SVG to create the custom dash pattern.
                                borderImageSource: 'url("data:image/svg+xml,%3csvg width=\'100%25\' height=\'100%25\' xmlns=\'http://www.w3.org/2000/svg\'%3e%3crect width=\'100%25\' height=\'100%25\' fill=\'none\' rx=\'8\' ry=\'8\' stroke=\'%23ccc\' stroke-width=\'2\' stroke-dasharray=\'8%2c 8\'/%3e%3c/svg%3e")',
                                borderImageSlice: '1',
                                minHeight: "168px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#757575",
                                cursor: "pointer",
                            }}
                        >
                            <Box
                                sx={{
                                    border: "1px solid #ddd",
                                    borderRadius: 2,
                                    backgroundColor: "#fff",
                                    p: 1.5,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    mb: 1,
                                    boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)"
                                }}
                            >
                                <Iconify
                                    icon="material-symbols:add-notes-outline-rounded"
                                    width={40}
                                    height={40}
                                    style={{ color: "#1a2b50" }}
                                />
                            </Box>
                            <Typography variant="body2">Drag & drop or click to choose files</Typography>
                            {/* <Typography */}
                            {/*    variant="caption" */}
                            {/*    sx={{ */}
                            {/*        display: "flex", */}
                            {/*        alignItems: "center", */}
                            {/*        gap: 0.5 */}
                            {/*    }} */}
                            {/* > */}
                            {/*    <Iconify */}
                            {/*        icon="mdi:information-outline" // info circle icon */}
                            {/*        width={14} */}
                            {/*        height={14} */}
                            {/*        style={{ color: "#757575" }} */}
                            {/*    /> */}
                            {/*    Max file size: 10MB */}
                            {/* </Typography> */}
                            <input
                                type="file"
                                multiple
                                onChange={handleSelectFile}
                                style={{ display: "none" }}
                            />
                        </Box>
                    ) : (
                        /* After Upload: Second Image Style */
                        <Box sx={{ display: "flex", gap: 2 }}>
                            {/* Left Upload Area */}
                            <Box
                                component="label"
                                sx={{
                                    border: '2px solid transparent',

                                    // Use the borderImageSource with an SVG to create the custom dash pattern.
                                    borderImageSource: 'url("data:image/svg+xml,%3csvg width=\'100%25\' height=\'100%25\' xmlns=\'http://www.w3.org/2000/svg\'%3e%3crect width=\'100%25\' height=\'100%25\' fill=\'none\' rx=\'8\' ry=\'8\' stroke=\'%23ccc\' stroke-width=\'2\' stroke-dasharray=\'8%2c 8\'/%3e%3c/svg%3e")',
                                    borderImageSlice: '1',
                                    minHeight: "168px",
                                    width: "250px", // Fixed width
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#757575",
                                    cursor: "pointer",
                                    flexShrink: 0,
                                }}
                            >
                                <Box
                                    sx={{
                                        border: "1px solid #ddd",
                                        borderRadius: 2,
                                        backgroundColor: "#fff",
                                        p: 1.5,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        mb: 1,
                                        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)"
                                    }}
                                >
                                    <Iconify
                                        icon="material-symbols:add-notes-outline-rounded"
                                        width={40}
                                        height={40}
                                        style={{ color: "#1a2b50" }}
                                    />
                                </Box>
                                <Typography variant="body2">Drag & drop or click to choose files</Typography>
                                {/* <Typography */}
                                {/*    variant="caption" */}
                                {/*    sx={{ */}
                                {/*        display: "flex", */}
                                {/*        alignItems: "center", */}
                                {/*        gap: 0.5 */}
                                {/*    }} */}
                                {/* > */}
                                {/*    <Iconify */}
                                {/*        icon="mdi:information-outline" // info circle icon */}
                                {/*        width={14} */}
                                {/*        height={14} */}
                                {/*        style={{ color: "#757575" }} */}
                                {/*    /> */}
                                {/*    Max file size: 10MB */}
                                {/* </Typography> */}
                                <input
                                    type="file"
                                    multiple
                                    onChange={handleSelectFile}
                                    style={{ display: "none" }}
                                />
                            </Box>

                            {/* Right File List */}
                            <Stack
                                spacing={1}
                                sx={{
                                    width: "545px", // Fixed width
                                    maxHeight: "168px",
                                    overflowY: "auto",
                                }}
                            >
                                {requestFile.map((file, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            border: "1px solid #ddd",
                                            borderRadius: 1,
                                            px: 1.5,
                                            py: 0.5,
                                            backgroundColor: "#f5f5f5",
                                        }}
                                    >
                                        <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1, overflow: "hidden", gap: 0.5 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>

                                                <Icon icon="tabler:file-text" width={18} height={18} style={{ color: "#616161" }} />
                                            </Box>
                                            <Typography
                                                variant="body2"
                                                noWrap
                                                title={file.name}
                                            >
                                                {file.name}
                                            </Typography>
                                        </Box>
                                        <IconButton
                                            edge="end"
                                            size="small"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                removeFile(index);
                                            }}
                                            sx={{
                                                color: '#FF1744',
                                                '&:hover': {
                                                    backgroundColor: 'rgba(255,23,68,0.1)',
                                                },
                                            }}
                                        >
                                            <Icon icon="material-symbols:delete-outline" width={17} height={17} />


                                        </IconButton>
                                    </Box>
                                ))}
                            </Stack>
                        </Box>

                    )}
                </Box>
            </Box>

            {openModalForCancel && <ModalPopUp openCloseValue={setOpenModalCancel} msg={message.forCancel} confirm={forCancelConfirm} />}
            {openModalForSaveService && (<ModalPopUp openCloseValue={setOpenModalForSaveService} msg="Are you sure you want to save the service ?" confirm={handleSaveServiceConfirm} />)}
            {openModalForDeleteService && (<ModalPopUp openCloseValue={setOpenModalForDeleteService} msg={
                <span>
                    Are you sure you want to delete the
                    <Typography
                        component="span"
                        color="secondary"
                        fontWeight="bold"
                    >
                        {" "}# Service - {deleteIndex + 1} ?
                    </Typography>
                </span>

            }
                confirm={handleDeleteServiceConfirm} />)}


        </>
    );
}